<template>
    <el-dialog class="dialog" :visible="dialogs.workFunctions" customClass="dialog_main" :append-to-body="true" :close-on-click-modal="false" @close="closeDialog()">
        <div slot="title" class="dialog__head dialog__head_second">
            <div class="dialog__head-inner">
                <h3 class="dialog__title">Трудовые функции</h3>
            </div>
        </div>

        <div class="dialog__inner">
            <div class="dialog__content">
                <form action="#" class="search-form" @submit.prevent="search">
                    <div class="search-form__inner">
                        <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': input && input.length !== 0 }" placeholder="Поиск" v-model.trim="input">

                        <button v-if="input && input.length !== 0" class="search-form__reset" @click="input = ''">
                            <icon-base viewBox="0 0 14 14"><icon-cancel /></icon-base>
                        </button>

                        <button type="submit" class="search-form__submit">
                            <icon-base viewBox="0 0 24 24"><icon-search /></icon-base>
                        </button>
                    </div>
                </form>

                <transition name="fade">
                    <div class="dialog__section" v-if="createEntity">
                        <h3>Заполните новую ТФ</h3>

                        <form class="entity-form" @submit.prevent="createItem">
                            <div class="entity-form__inner">
                                <div class="entity-form__item">
                                    <el-checkbox v-model="checkedWorkItem" />
                                </div>
                                <div class="entity-form__item entity-form__item_code">
                                    <masked-input 
                                        name="subcode"
                                        class="input"
                                        placeholder="Код"
                                        :class="{'input_error': subcodeError}"
                                        v-model="subcode"
                                        :mask="{
                                            pattern: '11.1'
                                        }"
                                    />
                                </div>
                                <div class="entity-form__item entity-form__item_name">
                                    <validate-input v-model="name" v-bind:error="nameError" v-on:update:error="nameError = $event" type="text" name="name" placeholder="Название" :validateOptions="['empty']" />
                                </div>
                                <div class="entity-form__item entity-form__item_select" @keyup.enter="searchForSelect">
                                    <v-select class="select" placeholder="Общая трудовая функция" label="name" name="common_function_id" v-model="commonFunction" :clearable="false" :options="commonWorkFunctionsOptions">
                                        <template #search="{attributes, events}">
                                            <input
                                                class="vs__search"
                                                v-bind="attributes"
                                                v-on="events"
                                                :required="!commonFunction"
                                            />
                                        </template>
                                        <template #no-options="{ search, searching, loading }">
                                            <local-preloader v-if="selectCommonWorkFunctionsPreloader" />
                                            <span v-else>Введите в поисковую строку и нажмите Enter, чтобы загрузить трудовые функции</span>
                                        </template>
                                        <template #open-indicator="{ attributes }">
                                            <span v-bind="attributes">
                                                <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                            </span>
                                        </template>
                                    </v-select>
                                </div>
                                <div class="entity-form__item entity-form__item_select">
                                    <v-select class="select" placeholder="Уровень квалификации" name="level" v-model="entityLevel" :clearable="false" :options="qualificationLevels">
                                        <template #search="{attributes, events}">
                                            <input
                                                class="vs__search"
                                                v-bind="attributes"
                                                v-on="events"
                                                :required="!entityLevel"
                                            />
                                        </template>
                                        <template #no-options="{ search, searching, loading }">
                                            {{ SELECT_NOT_FOUND }}
                                        </template>
                                        <template #open-indicator="{ attributes }">
                                            <span v-bind="attributes">
                                                <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                            </span>
                                        </template>
                                    </v-select>
                                </div>
                                <div class="entity-form__item">
                                    <button type="submit" :disabled="!subcode || subcodeError || !name || !commonFunction || !entityLevel" class="btn btn_action">Создать</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </transition>

                <h3 v-if="start" class="dialog__title mt-32 mb-32">Введите в поисковую строку или создайте новое ТФ, чтобы выбрать ТФ для добавления</h3>

                <div v-show="!start">
                    <el-table
                        cell-class-name="table__cell"
                        class="table table_second"
                        header-cell-class-name="table__title"
                        :max-height="createEntity ? 250 : 300"
                        ref="table"
                        row-key="id"
                        :data="filteredData"
                        :default-sort="{ prop: 'code', order: 'ascending' }"
                        @sort-change="sortChange"
                    >
                        <el-table-column
                                width="24"
                        >
                            <template slot-scope="scope">
                                <div class="table_flex">
                                    <el-checkbox @change="handleSelectionChange([scope.row])"/>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="Код"
                            prop="subcode"
                            sortable
                            :min-width="10"
                            :sort-orders="['ascending', 'descending']"
                        >
                            <template slot-scope="scope">
                                {{`${ scope.row.subcode }`}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="Название"
                            prop="name"
                            sortable
                            :min-width="90"
                            :sort-orders="['ascending', 'descending']"
                        >
                        </el-table-column>
                    </el-table>

                    <h3 class="dialog__title mt-32 mb-16">Выбранные сущности</h3>

                    <el-table
                        cell-class-name="table__cell"
                        class="table table_second"
                        header-cell-class-name="table__title"
                        :max-height="createEntity ? 250 : 300"
                        row-key="id"
                        :show-header="false"
                        :data="selection"
                        :default-sort="{ prop: 'code', order: 'ascending' }"
                    >
                        <el-table-column
                            width="24"
                        >
                            <template slot-scope="scope">
                                <div class="table_flex">
                                    <el-checkbox checked @change="deleteSelectionChange([scope.row])"/>
                                </div>
                            </template>
                        </el-table-column>
                    <el-table-column
                            label="Код"
                            prop="subcode"
                            sortable
                            :min-width="10"
                            :sort-orders="['ascending', 'descending']"
                        >
                            <template slot-scope="scope">
                                {{`${ scope.row.code }/${ scope.row.subcode }`}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="Название"
                            prop="name"
                            sortable
                            :min-width="90"
                            :sort-orders="['ascending', 'descending']"
                        >
                        </el-table-column>
                    </el-table>
                </div>
            </div>

            <footer slot="footer" class="dialog__footer mt-24">
                <div class="dialog__footer-inner">
                    <div class="dialog__footer-item">
                        <button type="button" class="btn" @click="closeDialog">Отменить</button>
                    </div>
                    <div class="dialog__footer-item">
                        <button type="submit" class="btn btn_action-second" :disabled="createEntity" @click="createEntity = true">
                            Создать новую ТФ

                            <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon"><icon-action /></icon-base>
                        </button>
                        
                        <button type="submit" class="btn btn_action" :disabled="selection.length === 0" @click="submitSelected">Добавить выбранные ТФ</button>
                    </div>
                </div>
            </footer>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import MaskedInput from 'vue-masked-input';

import constants from '@/constants.js';
import dialog from '@/mixins/dialog';
import ValidateInput from '@/components/ValidateInput'
import LocalPreloader from '@/components/LocalPreloader'

import { mergeArrsByKey } from '@/helpers';

export default {
    mixins: [ dialog ],
    components: {
        MaskedInput,
        ValidateInput,
        LocalPreloader
    },
    props: {
        qualificationId: {
            required: true,
            type: Number
        }
    },
    data() {
        return {
            checkedWorkItem: true,
            entityLevel: null,
            qualificationLevels: [1, 2, 3, 4, 5, 6],
            commonWorkFunctionsOptions: [],
            subcode: '',
            name: '',
            commonFunction: '',
            subcodeError: false,
            nameError: false,
            selectCommonWorkFunctionsPreloader: false,
            start: true
        }
    },
    methods: {
        ...mapActions('editor', [
            'LOAD_WORK_FUNCTIONS_BY_QUALIFICATION',
            'GET_WORK_ACTIONS_BY_QUALIFICATION',
            'GET_WORK_KNOWLEDGE_BY_QUALIFICATION',
            'GET_WORK_SKILLS_BY_QUALIFICATION',
            'SILENT_LOAD_COMMON_WORK_FUNCTIONS',
            'CREATE_WORK_FUNCTION',
            'QUERY_WORK_FUNCTIONS',
            'UPDATE_WORK_FUNCTIONS_BY_QUALIFICATION',
        ]),
        ...mapMutations('editor', ['SET_QUALIFICATIONS', 'GROUP_QUALIFICATIONS']),

        closeDialog() {
            this.subcode = ''
            this.name = ''
            this.commonFunction = ''
            this.createEntity = false
            this.subcodeError = false
            this.nameError = false
            this.start = true
            this.commonWorkFunctionsOptions = []

            this.selection = []

            this.elDialogs.workFunctions = false;
        },
        async searchForSelect(val) {
            this.selectCommonWorkFunctionsPreloader = true
            await this.SILENT_LOAD_COMMON_WORK_FUNCTIONS(val.target.value)
            this.commonWorkFunctionsOptions = JSON.parse(JSON.stringify(this.commonWorkFunctions))
            this.selectCommonWorkFunctionsPreloader = false
        },
        async createItem(e) {
            // Собираем новые значения и отправляем
            const formData = new FormData(e.target);

            const params = {
                level: this.entityLevel,
                'common_function_id': this.commonFunction.id
            };

            for (const pair of formData.entries()) {
                params[pair[0]] = pair[1];
            }

            const newWorkFunction = await this.CREATE_WORK_FUNCTION(params);
            this.data = [...this.workFunctions];

            if (this.checkedWorkItem) {
                this.selection.push(newWorkFunction);
            }
            this.start = false

            e.target.reset();
        },
        handleSelectionChange(val) {
            this.selection = [...val, ...this.selection];
        },
        deleteSelectionChange(val) {
            this.selection = this.selection.filter(select => !val.find(item => item.id === select.id))
        },
        async search() {
            await this.QUERY_WORK_FUNCTIONS(this.input).then(() => {
                this.data = [...this.workFunctions];
            });
            this.start = false

            let workFunctions = []
            this.workFunctionsByQualification.forEach(element => {
                workFunctions.push(element.work_functions)
            });
            workFunctions = workFunctions.flat().map(el => el.id)
            this.data = this.data.filter(el => !workFunctions.includes(el.id))
        },
        sortChange(v) {
            if (v.column.order === 'ascending') {
                this.data.sort(this.sortListAsc(v.column.property));
            } else if (v.column.order === 'descending') {
                this.data.sort(this.sortListDesc(v.column.property));
            }
        },
        async submitSelected() {
            const ids = this.selection.map((item) => item.id);

            await this.UPDATE_WORK_FUNCTIONS_BY_QUALIFICATION({
                qualificationId: this.qualificationId,
                ids
            })

            await this.LOAD_WORK_FUNCTIONS_BY_QUALIFICATION(this.qualificationId)
            await this.GET_WORK_ACTIONS_BY_QUALIFICATION(this.qualificationId)
            await this.GET_WORK_KNOWLEDGE_BY_QUALIFICATION(this.qualificationId)
            await this.GET_WORK_SKILLS_BY_QUALIFICATION(this.qualificationId)

            let workFunctionsLength = 0
            this.workFunctionsByQualification.forEach(element => {
                workFunctionsLength += element.work_functions.length
            });

            const tempQualifications = JSON.parse(JSON.stringify(this.qualifications))
            await this.SET_QUALIFICATIONS(tempQualifications.map(qualification => qualification.id === this.qualificationId ? Object.assign(qualification, { 'work_functions': workFunctionsLength, 'work_actions': this.workActions.length, 'work_knowledge': this.workKnowledge.length, 'work_skills': this.workSkills.length }) : qualification))
            this.GROUP_QUALIFICATIONS(this.groupItemsBy.name);

            this.closeDialog()
        }
    },
    computed: {
        ...mapState('editor', ['workFunctions', 'workActions', 'workKnowledge', 'workSkills', 'workFunctionsByQualification', 'commonWorkFunctions', 'qualifications', 'groupItemsBy']),

        filteredData() {
            return this.data.filter(el => !this.selection.find(select => select.id === el.id))
        }
    },
    watch: {
        subcode: function(val) {
            if (!val) this.subcodeError = true
            else if (val.includes('_')) this.subcodeError = true
            else this.subcodeError = false
        }
    },
    created() {
        this.SELECT_NOT_FOUND = constants.SELECT_NOT_FOUND;
    }
}
</script>
